export const STEPS = {
  CHOOSE_MIGRATION_OPTION: 'choose_migration_option',
  FTP_MIGRATION_FORM: 'ftp_migration_form',
  FILES_MIGRATION: 'files_migration',
  SUCCESS: 'success',
};

export const initialStep = STEPS.CHOOSE_MIGRATION_OPTION;
